export const NIS_REQUEST = 'NIS_REQUEST';
export const NIS_SUCCESS = 'NIS_SUCCESS';
export const NIS_FAIL = 'NIS_FAIL';